import React, { useEffect, useState, useRef } from 'react';
import type { ReactNode, ReactElement, FC } from 'react';
import './index.css';

function defaultRenderComponent(): void {
  console.warn('SCComponent needs to initialize SCComponentRoot before use。');
}

interface SCComponentRootType {
  renderComponent: (key: string, Component: ReactNode | null) => void;
}

const SCComponentRoot: FC & SCComponentRootType = () => {
  const refUnMount = useRef(false);
  const [components, setComponents] = useState<{
    [key: string]: ReactNode | null;
  }>({});

  useEffect(() => {
    // StrictMode run effect twice
    refUnMount.current = false;

    function renderComponent(key: string, Component: ReactNode | null) {
      // No need to run if unmounted.
      if (refUnMount.current) {
        return;
      }

      setComponents((prev) => {
        const newComponents = { ...prev };
        if (Component === null) {
          delete newComponents[key];
        } else {
          newComponents[key] = Component;
        }

        return newComponents;
      });
    }

    // Register
    SCComponentRoot.renderComponent = renderComponent;

    return () => {
      refUnMount.current = true;
      // Restore
      SCComponentRoot.renderComponent = defaultRenderComponent;
    };
  }, []);

  return (
    <div className="sce-component-root-container">
      {Object.keys(components).map((key) => {
        return React.cloneElement(components[key] as ReactElement, {
          key,
        });
      })}
    </div>
  );
};

SCComponentRoot.renderComponent = defaultRenderComponent;

export { SCComponentRoot };
